import {
    Badge,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "helpers";
import { BsBell } from "react-icons/bs";
import HtmlRenderer from "components/HtmlRenderer";
import { useGetNotificationsQuery, useMarkNotificationAsReadMutation } from "redux/service/notifications";
import MyPopover from "./MyPopover";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Notifications = ({ className = "" }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const authData = useSelector(s => s.auth.data);

    const notificationsRes = useGetNotificationsQuery({ limit: 10 }, {
        pollingInterval: 15 * 1000,
        skipPollingIfUnfocused: true,
    });

    const [markNotificationAsRead] = useMarkNotificationAsReadMutation();

    const handleOnScroll = (event) => {
        if (Math.abs(event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop) < 1) {
            // here load more notifications
            // this functionality is under progress
            console.log("load more notifications");
        }
    };

    const unReadNotificationsCount = useMemo(
        () => (notificationsRes.isSuccess ? notificationsRes.data.filter((r) => !r.is_read).length : 0),
        [notificationsRes]
    );

    return (
        <>
            <MyPopover
                name="notification"
                trigger={(openFn) => (
                    <Tooltip title={t("715", "Notifications")}>
                        <Badge
                            className={`me-2 h-15px d-inline-block align-top ${className}`}
                            variant="dot"
                            badgeContent={unReadNotificationsCount}
                            color="primary"
                            onClick={openFn}
                            sx={{ cursor: 'pointer' }}
                        >
                            <BsBell className="align-top text-dark" />
                        </Badge>
                    </Tooltip>
                )}
            >
                <>
                    <Typography sx={{ p: 1, textAlign: "center" }}>
                        <h4 className="text-dark mb-0">{t("715", "Notifications")}</h4>
                    </Typography>

                    {notificationsRes.isLoading ? (
                        <></>
                    ) : notificationsRes.isError ? (
                        <p className="text-center">Error loading notifications</p>
                    ) : notificationsRes.isSuccess ? (
                        <>
                            <List
                                className="custom_notification_scrollbar"
                                sx={{
                                    width: "100%",
                                    maxWidth: 300,
                                    bgcolor: "var(--theme-light)",
                                    position: "relative",
                                    overflow: "auto",
                                    maxHeight: 300,
                                    paddingBottom: 0,
                                    "& .MuiDivider-inset": { margin: 0 },
                                    "& .MuiListItemText-root": { margin: 0 },
                                    "& .MuiTypography-root": { margin: 0 },
                                }}
                                subheader={<li />}
                                onScroll={handleOnScroll}
                            >
                                {notificationsRes.data.length > 0 ? (
                                    <>
                                        {notificationsRes.data
                                            .filter((noti) => noti.role_id === authData.role_id)
                                            .map((noti) => (
                                                <div key={`notification-${noti.id}`}>
                                                    <ListItemButton
                                                        sx={{ p: 0, width: "100%" }}
                                                        selected={!noti.is_read}
                                                        onClick={() => markNotificationAsRead(noti.id)}
                                                    >
                                                        <ListItem className="d-block d-flex">
                                                            {[true, 1].includes(noti.is_coming) ? (
                                                                <i className="fa-solid fs-4 fa-arrow-down text-primary"></i>
                                                            ) : (
                                                                <i className="fa-solid fs-4 fa-arrow-up text-primary"></i>
                                                            )}
                                                            <HtmlRenderer className="ms-4" htmlContent={noti.content} />
                                                        </ListItem>
                                                    </ListItemButton>
                                                    <em className="d-flex flex-end fs-9">{getFormattedDate(noti.createdAt)}</em>
                                                    <Divider variant="inset" component="li" />
                                                </div>
                                            ))}


                                    </>
                                ) : (
                                    <>
                                        <ListItem sx={{ width: "100%" }}>
                                            <ListItemText
                                                primary={t("959", "No Notifications Available")}
                                                sx={{ textAlign: "center" }}
                                            />
                                        </ListItem>
                                        <Divider variant="inset" component="li" />
                                    </>
                                )}
                                <div style={{ textAlign: "center", padding: "10px" }}>
                                    <Link to={"/portal/notification-management"} className="ms-auto">
                                        {t("-t", "View More")}
                                    </Link>
                                </div>
                            </List>
                        </>
                    ) : null}
                </>
            </MyPopover>
        </>
    );
};

export default Notifications;
